@if (anchor) {
  <a [id]="anchor"></a>
}

<app-translation-switch kb-section></app-translation-switch>

@if (attributes.headline) {
  <h1 kb-heading [appEditorId]="editorIds?.headline">{{attributes.headline}}</h1>
}

@if (breadcrumb$ | async; as breadcrumb) {
  <nav kb-breadcrumb-navigation [navigation]="breadcrumb.navigation" [homeLink]="breadcrumb.homeLink"></nav>
}

@if (attributes.date || attributes.abstract) {
  <div class="abstract-container" kb-section>
    @if (attributes.date) {
      <time kb-paragraph [attr.datetime]="attributes.date | date:'yyyy-MM-dd hh:mm:ssZZZZZ'" [appEditorId]="editorIds?.date">{{attributes.date | date:'longDate'}}</time>
    }
    @if (attributes.abstract) {
      <kb-html class="abstract" [appEditorId]="editorIds?.abstract" [html]="attributes.abstract"></kb-html>
    }
  </div>
}

@if (attributes.text) {
  <kb-html kb-section class="text" [appEditorId]="editorIds?.text" [html]="attributes.text"></kb-html>
}
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
